

import HelpOutlineIcon from '@mui/icons-material/HelpOutline';
// import PhoneInTalkIcon from '@mui/icons-material/PhoneInTalk';
import TextsmsOutlinedIcon from '@mui/icons-material/TextsmsOutlined';
import AccountTreeIcon from '@mui/icons-material/AccountTree';
import LocalPrintshopOutlinedIcon from '@mui/icons-material/LocalPrintshopOutlined';
import DescriptionOutlinedIcon from '@mui/icons-material/DescriptionOutlined';
import GroupOutlinedIcon from '@mui/icons-material/GroupOutlined';
import ArchiveOutlinedIcon from '@mui/icons-material/ArchiveOutlined';
import EventNoteOutlinedIcon from '@mui/icons-material/EventNoteOutlined';
import HourglassEmptyOutlinedIcon from '@mui/icons-material/HourglassEmptyOutlined';


export interface menuDetail {
    menuName: string
    routePath?: string
    icon: React.ReactNode,
    disabled?: boolean
    externalUrl?: string
    downloadUrl?: string
    action?: 'connect-scale'
}


// export const MenusDetail: menuDetail[] = [
//     {
//         menuName: "Mint Registration",
//         routePath: "mintRegistration",
//         icon: <GroupOutlinedIcon />
//     },
// Global menu options (shown on all pages)
export const GlobalMenuOptions: menuDetail[] = [
    {
        menuName: "User Management",
        routePath: "userManagement",
        icon: <GroupOutlinedIcon />
    },
    {
        menuName: "User Manual",
        routePath: "user-manual",
        icon: <HelpOutlineIcon />,
        externalUrl: "https://syngenta.sharepoint.com/:w:/r/sites/VegGlobalITCollaboration/Shared%20Documents/S2S%20(Shared%20with%20Infosys)/Technical/User%20Manual/User%20Manual%20v1.docx?d=wb4af5a5329934a44bde14cfb0da069df&csf=1&web=1&e=heJch4"
    },
    // {
    //     menuName: "Contact Info",
    //     routePath: "contact-info",
    //     icon: <PhoneInTalkIcon />
    // },
    {
        menuName: "Feedback",
        routePath: "feedback",
        icon: <TextsmsOutlinedIcon />
    },
    {
        menuName: "Connect Scale",
        action: "connect-scale",
        icon: <HourglassEmptyOutlinedIcon />
    }
]

// Post-season module specific options
export const PostSeasonModuleOptions: menuDetail[] = [
    {
        menuName: "Configure Workflow",
        routePath: "workflow",
        icon: <AccountTreeIcon />
    },
    {
        menuName: "Label Template",
        routePath: "label-templates",
        icon: <LocalPrintshopOutlinedIcon />
    },
    {
        menuName: "Archived Data",
        routePath: "splot?isArchived=true",
        icon: <ArchiveOutlinedIcon />
    },
    {
        menuName: "Download Reports",
        routePath: "events-report",
        icon: <EventNoteOutlinedIcon />
    },
    {
        menuName: "MINT Registration",
        routePath: "mintRegistration",
        icon: <DescriptionOutlinedIcon />
    },

]

export const InSeasonModuleOptions: menuDetail[] = [
    {
        menuName: "Harvest Requests",
        routePath: "harvest-req",
        icon: <img
            src={"icons/hfReq.svg"}
            width={20}
            height={20}
        />,

    },
    {
        menuName: "Pollination Requests",
        routePath: "workflow",
        icon: <img
            src={"icons/pollReq.svg"}
            width={20}
            height={20}
        />,
        disabled: true

    },
    {
        menuName: "Phenotyping Data",
        routePath: "label-templates",
        icon: <img
            src={"icons/pheno.svg"}
            width={20}
            height={20}
        />,
        disabled: true


    },
    {
        menuName: "Agronomic Practices",
        routePath: "mintRegistration",
        icon: <img
            src={"icons/agPract.svg"}
            width={20}
            height={20}
        />,
        disabled: true
    },
  {
        menuName: "Harvest Data",
        routePath: "mintRegistration",
        icon: <img
            src={"icons/materials_icon.png"}
            width={20}
            height={20}
        />,
        disabled: true
    },


    // {
    //     menuName: "Harvest Data",
    //     routePath: "splot?isArchived=true",
    //        icon:<img
    //         src={"icons/SP_Lots_Icon.svg"}
    //         width={20}
    //         height={20}
    //     />
    // }
]




// Legacy export for backward compatibility
export const MenusDetail: menuDetail[] = GlobalMenuOptions


